import {ref} from "vue";

const permissions = ref([]);

export function usePermission() {
  const can = (permission) => permissions.value.indexOf(permission) > -1;
  const setPermissions = (list) => permissions.value = list;

  return {
    can,
    setPermissions
  }
}
